/**
 * InspirationExplorer.config.js
 *
 * Static configuration for the Inspiration Explorer tool.
 * Controls copy, style groups, budget ranges, and defaults.
 */

const InspirationExplorerConfig = {
  id: "inspirationExplorer",

  title: "Explore Design Ideas for Your Home",

  description:
    "Browse common styles and budget ranges to get a feel for what your project could look like.",

  ctaLabel: "Show Me Ideas",

  /**
   * Default selections
   */
  defaults: {
    style: "",
    budget: "",
  },

  /**
   * Style options
   */
  styleGroups: [
    { value: "modern", label: "Modern" },
    { value: "traditional", label: "Traditional" },
    { value: "farmhouse", label: "Farmhouse" },
    { value: "contemporary", label: "Contemporary" },
    { value: "transitional", label: "Transitional" },
  ],

  /**
   * Budget ranges (intentionally broad and non-specific)
   */
  budgetRanges: [
    { value: "budget", label: "Budget-friendly" },
    { value: "midrange", label: "Mid-range" },
    { value: "highend", label: "Higher-end" },
  ],

  /**
   * Category-specific overrides (optional, future use)
   */
  categoryOverrides: {
    "bathroom-remodeling": {
      styleGroups: [
        { value: "spa", label: "Spa-inspired" },
        { value: "modern", label: "Modern" },
        { value: "classic", label: "Classic" },
      ],
    },

    "kitchen-cabinet-refacing": {
      styleGroups: [
        { value: "shaker", label: "Shaker" },
        { value: "flat", label: "Flat-panel" },
        { value: "raised", label: "Raised panel" },
      ],
    },
  },

  /**
   * Result copy
   */
  result: {
    title: "Design Inspiration Overview",
    disclaimer:
      "These examples are for inspiration only. Actual designs and costs may vary based on your home and preferences.",
  },
};

export default InspirationExplorerConfig;
